import { createSelector } from '@ngrx/store';
import { AppState } from '../app.store';
import { LanguageState } from 'src/app/core/models/language.model';
export const selectLanguageState = (state: AppState):LanguageState  => state.language;

export const selectCurrentLanguage = createSelector(
  selectLanguageState,
  (languageState:LanguageState) => languageState.currentLanguage
);
